<script>
export default ({
    async created() {
        console.log("Evaluating Organisation Context...");

        // FIX: If Validation.vue already established a valid organisation context, 
        // bypass the network query to avoid race condition state overwrites
        if (this.$store.state.auth.organisation && this.$store.state.auth.org_id) {
            this.proceedToDashboard();
            return;
        }

        // Context recovery path for manual browser page refreshes (F5)
        if (this.$store.state.auth.isSuperAdmin) {
            const isSuccess = await this.getXSurflogOrganisations();
            if (isSuccess) {
                this.proceedToDashboard();
            } else {
                this.$router.push({ name: 'index' });
            }
        } else {
            this.proceedToDashboard();
        }
    },

    methods: {
        // FIX: Added explicit promise handles so that async/await evaluations track accurately
        async getXSurflogOrganisations() {
            try {
                const response = await this.$axios.get("/admin-common/get-xsurflog-organisations");
                
                if (response.data.organisations && response.data.organisations.length > 0) {
                    this.$store.commit("auth/setOrganisations", response.data.organisations);
                    
                    // Fallback to the first record ONLY if no targeted organisation is active
                    if (!this.$store.state.auth.organisation) {
                        let activeOrg = null;
                        const targetUuid = this.$store.state.auth.jwtPayload?.organisation_uuid;
                        if (targetUuid) {
                            activeOrg = response.data.organisations.find(org => org.orguuid === targetUuid);
                        }
                        if (!activeOrg) {
                            activeOrg = response.data.organisations[0];
                        }
                        this.$store.commit("auth/setOrganisation", activeOrg);
                        this.CheckAccount(activeOrg.orguuid, activeOrg.name);
                    }
                }
                return true;
            } catch (error) {
                console.error("Failed to recover organisation scope on refresh:", error);
                return false;
            }
        },

        proceedToDashboard() {
            const targetPath = this.$store.state.auth.redirectLink;
            this.$store.commit("auth/setRedirectLink", null);
            
            const normalizedPath = targetPath ? targetPath.replace(/\/$/, "") : "";
            if (
                normalizedPath &&
                normalizedPath !== "/main" &&
                normalizedPath !== "/validation" &&
                normalizedPath !== "/dashboard-validation"
            ) {
                this.$router.push({ path: targetPath });
            } else {
                this.$router.push({ name: 'dashboard' });
            }
        },

        async CheckAccount(OrgUuid, Name) {
            try {
                const payLoad = { org_uuid: OrgUuid, name: Name };
                fetch(process.env.VUE_APP_API_BASE_URL + "/api/main/v1/auth/non-login/check-account-exist", {
                    method: "POST",
                    body: JSON.stringify(payLoad),
                    headers: { "Content-type": "application/json; charset=UTF-8" }
                });
            } catch (error) {
                console.error("Account lookup network drop:", error);
            }
        }
    }
})
</script>